export default "/images/timer-log.svg?50c49af61793eef17138757043fb404c";